// @flow
import { Map } from 'immutable';

import * as c from './constants';

const initialState = new Map();

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case c.CONFIRM_DIALOG:
    case c.ERROR_DIALOG:
      return state.set(action.payload.id, { ...action.payload, type: action.type });

    case c.RESOLVE_DIALOG:
      return state.delete(action.payload.id);

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/common/components/dialog/reducer.js